import type { ReadonlyDeep } from 'type-fest';

import { ResolvableAmountInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';
import type { ResolvableAmountCmp_ResolvableAmount } from '../../../components/ResolvableFields/ResolvableAmount';

import { resolvableFloatForm2ApiMapper } from './resolvable-float.form2api.mapper';
import { resolvableIdForm2ApiMapper } from './resolvable-id.form2api.mapper';

export function resolvableAmountForm2ApiMapper(
  resolvableAmount: Readonly<ResolvableAmountCmp_ResolvableAmount>,
): ReadonlyDeep<ResolvableAmountInput> {
  const resolvableAmountInput = pruneInput(
    resolvableAmount,
    ResolvableAmountInput,
  );

  return {
    ...resolvableAmountInput,
    value: resolvableFloatForm2ApiMapper(resolvableAmount.value),
    currencyId: resolvableIdForm2ApiMapper(resolvableAmount.currencyId),
  };
}
